import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import appReducers from './appReducers';
import sagas from './sagas';

const initialState = {};
const devMode = process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const composeEnhancers = devMode ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;
const sagaMiddleware = createSagaMiddleware();
const middleware = [
  sagaMiddleware,
  devMode && reduxImmutableStateInvariant(),
];

const store = createStore(
  appReducers,
  initialState,
  composeEnhancers(applyMiddleware(...middleware)),
);

sagaMiddleware.run(sagas);

export default store;
